import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { queryClient } from "../../providers/QueryProvider";
import SecureStorage from "../../utils/secureStorage";
import useAppLocalStorage from "../../hooks/useAppLocalStorage";

const Logout = () => {
  const localStorage = useAppLocalStorage();

  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    SecureStorage.clearAuthData();

    SecureStorage.clearUserPreferences();

    auth.logout();

    queryClient.clear();

    navigate("/");
  }, [auth, navigate, localStorage]);

  return null;
};

export default Logout;
